import '../styles/index.css';
import '../styles/main.scss';
import FormValidator from '@client/utils/input-validation';
import PasswordToggle from '@client/utils/password-toggle';
import initCookieConsent from '@client/utils/cookieconsent-config';
import Menu from '@client/components/ui/menu/menu';
import CloseNotification from '@client/components/ui/notifications/close-notification';
import MatchHeight from '@client/utils/match-height';
import CharacterCounter from '@client/utils/CharacterCounter';
import AccordionToggle from '@client/utils/accordion-toggle';
import tableOfcontent from '@client/utils/tabel-of-content';
import externalLink from '@client/utils/external-link';
import BackToTop from '@client/utils/back-to-top';
import PDFPrint from '@client/utils/pdf-print';
import NavSearch from '@client/utils/nav-search';

document.addEventListener('DOMContentLoaded', () => {
  new FormValidator();
  PasswordToggle();
  initCookieConsent();
  Menu();
  CloseNotification();
  CharacterCounter();
  MatchHeight();
  AccordionToggle();
  tableOfcontent();
  externalLink();
  BackToTop();
  PDFPrint();
  NavSearch();
});
